// extracted by mini-css-extract-plugin
module.exports = {"cso22":"OlympiadPrivateQualifier_cso22__wQf7j","title":"OlympiadPrivateQualifier_title__2j4K_","text":"OlympiadPrivateQualifier_text__3OsgY"};